(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/score-item.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/score-item.js');
"use strict";

const {
  useState,
  useCallback,
  useMemo,
  useEffect
} = React;
const {
  PositionDirection
} = svs.components.marketplaceCompetition.services.constants.highscoreConstants;
const {
  ReactIcon,
  ReactIconButton
} = svs.ui;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useCompetitionType
} = svs.components.marketplaceCompetition.services.hooks;
const {
  analytics
} = svs.components;
const trackEventOnOverviewTeam = (competition, position, isPersonal) => {
  if (competition.compType) {
    analytics.trackEvent({
      category: competition.compType,
      action: 'overview team',
      opt_label: "".concat(position, "-").concat(isPersonal ? 'Personal' : 'Highscore') 
    });
  }
};
const ScoreItem = _ref => {
  let {
    position,
    direction,
    name,
    location,
    currentScore,
    totalScore,
    Details,
    isTeam,
    Initials,
    competitionBranding,
    isPersonal = false
  } = _ref;
  const competitionId = useCompetitionId();
  const competitionType = useCompetitionType(competitionId);
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const [isShowingDetails, setIsShowingDetails] = useState(false);
  const toggleShowingDetails = useCallback(() => {
    setIsShowingDetails(oldValue => !oldValue);
  }, []);
  const containerClassName = ['highscore-item-container'];
  if (isPersonal) {
    containerClassName.push('highscore-item-container-personal');
  }
  if (competitionBranding) {
    containerClassName.push("highscore-item-container-".concat(competitionBranding));
  }
  const shouldShowInitials = isSmall && Boolean(Initials);
  if (shouldShowInitials) {
    containerClassName.push('highscore-item-container-initials');
  }
  const movedUpIcon = useMemo(() => {
    if (direction === PositionDirection.Up) {
      return React.createElement(ReactIcon, {
        className: "highscore-item-position-up",
        color: "fc-green",
        icon: "caret-up",
        size: "100"
      });
    }
    return null;
  }, [direction]);
  const movedDownIcon = useMemo(() => {
    if (direction === PositionDirection.Down) {
      return React.createElement(ReactIcon, {
        className: "highscore-item-position-down",
        color: "fc-red",
        icon: "caret-down",
        size: "100"
      });
    }
    return null;
  }, [direction]);
  useEffect(() => {
    if (isShowingDetails && isTeam) {
      trackEventOnOverviewTeam({
        compType: competitionType
      }, position, isPersonal);
    }
  }, [isShowingDetails, isTeam, isPersonal, position, competitionType]);
  return React.createElement("div", {
    className: containerClassName.join(' ')
  }, React.createElement("span", {
    className: "highscore-item-position"
  }, movedUpIcon, React.createElement("span", {
    className: "highscore-item-position-number"
  }, position), movedDownIcon), Boolean(Initials) && isSmall && React.createElement(Initials, null), !location && React.createElement("span", {
    className: "highscore-item-full-name highscore-item-full-name-oneline"
  }, name), location && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "highscore-item-full-name"
  }, name), React.createElement("span", {
    className: "highscore-item-location"
  }, location)), React.createElement("span", {
    className: "highscore-item-currentscore"
  }, currentScore), React.createElement("span", {
    className: "highscore-item-totalscore"
  }, totalScore), React.createElement("span", {
    className: "highscore-item-more"
  }, React.createElement(ReactIconButton, {
    onClick: toggleShowingDetails
  }, React.createElement(ReactIcon, {
    icon: isShowingDetails ? 'menu-up' : 'menu-down',
    size: "100"
  }))), isShowingDetails && React.createElement("div", {
    className: "highscore-item-details-container"
  }, React.createElement(Details, null)));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.ScoreItem', ScoreItem);

 })(window);